import React from 'react'
import TextLink from '../TextLink/TextLink'
import { useAuth } from '../../../context/Auth'
import { useBp } from '../../../utils/Breakpoints/Breakpoints'

import IconButtonGroup from '../Header/IconButtonGroup/IconButtonGroup'
import Divider from '../Divider/Divider'

import './Footer.scss'

const Footer = () => {
  const date = new Date()

  const { currentUser, logout } = useAuth()
  const aboveXxs = useBp('> xxs')

  return (
    <footer>
      <div className='inner-container'>
        <IconButtonGroup />
        <Divider type='horizontal' />
        <div className='footer-info'>
          <span className='copyright'>{`\u00a9 ${date.getFullYear()} Jason Cardarelli`}</span>
          {currentUser && (
            <>
              {aboveXxs && <span className='bullet-point'>&bull;</span>}
              <div className='links'>
                <TextLink to='/changelog' label='Changelog' />
                <span className='bullet-point'>&bull;</span>
                <button className='text-link' onClick={() => logout()}>
                  Lock portfolio
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </footer>
  )
}

export default Footer
